// import {GetMyCharacterLevel} from '@/graphql/queries/CharacterLevel.graphql'
import {GetFlashLineSet} from '@/graphql/mutations/FlashLine.graphql'

export default {
  data(){
    return {
      isMountedLoginedPage : false
    };
  },

  computed : {
    isLoginedView(){
      return this.$store.state.layouts.loginedView;
    }
  },

  methods : {
    initializePageParameters(payload){
      if(typeof payload === 'undefined') payload = {};

      payload = this._.merge({
        'title' : ''
      },payload);

      return payload;
    },

    async setPageTitle(payload){
      if((payload.title === '') || (payload.title === null)) return;

      await this.$store.dispatch({
        type  : 'updatePageTitle',
        title : payload.title,
      });
    },

    async initializePage(payload){
      payload = this.initializePageParameters(payload);

      await this.$store.dispatch({
        type  : 'layouts/updateIsVisiblePageContent',
        value : false
      });

      await this.setPageTitle(payload);

      // 一つ前に表示していたページがfrontの場合はLoadingを表示させます。
      if(this.isLoginedView === true){
        await this.$store.dispatch({
          type  : 'globalLoading/updateGlobalLoading',
          value : false,
        });

        await this.$store.dispatch({
          type  : 'layouts/updateIsVisiblePageContent',
          value : true
        });
      }else{
        await this.$store.dispatch({
          type  : 'globalLoading/updateGlobalLoading',
          value : true,
        });

        await this.$store.dispatch({
          type  : 'layouts/updateLoginedView',
          value : true,
        });

        await this.$store.dispatch({
          type  : 'layouts/updateMountedLayoutStyleName',
          value : 'home'
        });

        this.$store.dispatch({
          type  : 'layouts/updateIsNoBodyPullToRefreshAndroid',
          value : true
        });

        // ユーザー認証とGetMeなどしています。
        await this.checkAuthenticationLoginedPage();

        // FlashLineを取得します。
        await this.getFlashLineData();

        await this.$store.dispatch({
          type  : 'globalLoading/updateGlobalLoading',
          value : false,
        });

        await this.$store.dispatch({
          type  : 'layouts/updateIsVisiblePageContent',
          value : true
        });
      }

      this.$nextTick(() => {
        this.isMountedLoginedPage = true;
        
        this.$emit('mountedPage');
        this.$parent.$emit('mountedPage');

        this.$parent.$emit('mountedLoginedPage');
      });
    },

    getFlashLineData(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : GetFlashLineSet,
          variables : {},
        }).then(async ({data: {flashLineSet}}) => {
          for(let item of flashLineSet.global){
            if(item.loop === false) continue;
            if(item.slug !== 'default') continue;
            
            this.$store.dispatch({
              type  : 'timesFlashLine/pushFlashMessage',
              line  : 'loop',
              data  :       {
                type    : item.message_type,
                message : item.message,
                loop    : item.loop, // trueの場合は無限、数字指定で回数、falseで１回
              }
            });
          }
          
          resolve(true);
        }).catch(() => {
          resolve(false);
        });
      });
    }
  }
}